import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { PaginatorModule } from 'primeng/paginator';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BikePremiumCalculationService } from '@base/app/features/calculator-overview/services/bike-premium-calculation.service';
import { BikeProductCardComponent } from '../bike-product-card/bike-product-card.component';
import { triggerSlideUpAnimation } from '../../../../shared/animations/fade-in.animation';
import { ServoBikeProductType } from '@base/backend';
import { BikeCalculatorFormModel, createBikeCalculatorForm } from '../../factories/bike-calculator-form.factory';
import { BikeService } from '../../services/bike.service';

@Component({
  selector: 'app-bike-calculator-with-products',
  standalone: true,
  imports: [
    PaginatorModule,
    ReactiveFormsModule,
    BikeProductCardComponent
  ],
  providers: [BikePremiumCalculationService],
  templateUrl: './bike-calculator-with-products.component.html',
  styleUrl: './bike-calculator-with-products.component.scss',
  animations: [triggerSlideUpAnimation]
})
export class BikeCalculatorWithProductsComponent implements OnInit {
  private readonly bikeService = inject(BikeService);

  protected readonly ServoBikeProductType = ServoBikeProductType;

  @Input() set presetValues(params: { isEbike: boolean | null, price: number } | null) {
    if (params) {
      this.form.controls.isEbike.setValue(params.isEbike);
      this.form.controls.price.setValue(params.price);

      this.calculatePremiums();
      this.showProducts = true;
    }
  }

  @Output() requestOffer = new EventEmitter<{
    isEbike: boolean,
    price: number,
    premium: number,
    bikeProductType: ServoBikeProductType
  }>();

  form!: FormGroup<BikeCalculatorFormModel>;

  premiumForDiebstahl: number | null = null;
  premiumForKompakt: number | null = null;
  premiumForPremium: number | null = null;

  showProducts = false;

  ngOnInit() {
    this.form = createBikeCalculatorForm();
  }

  calculatePremiums(): void {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      return;
    }

    const price = this.form.controls.price.value!;

    this.bikeService.getPremium(price, undefined, ServoBikeProductType.Diebstahl)
      .subscribe(premium => {
        this.premiumForDiebstahl = premium;
      });

    this.bikeService.getPremium(price, undefined, ServoBikeProductType.KompaktPaket)
      .subscribe(premium => {
        this.premiumForKompakt = premium;
      });

    this.bikeService.getPremium(price, undefined, ServoBikeProductType.PremiumPaket)
      .subscribe(premium => {
        this.premiumForPremium = premium;
      });

    this.showProducts = true;
    window.setTimeout(() => {
      const row = document.getElementById('product-row')!;
      window.scrollTo({ top: row.offsetTop - 10, behavior: 'instant' });
    }, 10);
  }

  submit(bikeProductType: ServoBikeProductType): void {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      return;
    }

    const payload = {
      isEbike: this.form.controls.isEbike.value!,
      price: this.form.controls.price.value!
    };

    if (bikeProductType === ServoBikeProductType.Diebstahl) {
      this.requestOffer.emit({
        ...payload,
        bikeProductType: ServoBikeProductType.Diebstahl,
        premium: this.premiumForDiebstahl!
      });
    } else if (bikeProductType === ServoBikeProductType.KompaktPaket) {
      this.requestOffer.emit({
        ...payload,
        bikeProductType: ServoBikeProductType.KompaktPaket,
        premium: this.premiumForKompakt!
      });
    } else if (bikeProductType === ServoBikeProductType.PremiumPaket) {
      this.requestOffer.emit({
        ...payload,
        bikeProductType: ServoBikeProductType.PremiumPaket,
        premium: this.premiumForPremium!
      });
    }
  }
}
